import { tvModeActive } from '@classes/app_url_params'
import type { MapConfig } from '@constants/types'
import { MapboxLayers, WindyLayers } from '@shared_types/map_types'

import type { UpdateMapConfigAction } from '../actions'
import { UPDATE_ACTIVE_LAYER, UPDATE_ACTIVE_MAP, UPDATE_MAP_ZOOM } from '../actions'

export const INIT_ZOOM = 7
export const ZOOM_FACTOR = 0.9

const initialState: MapConfig = {
  activeMap: tvModeActive() ? 'mapbox2d' : 'windy',
  zoom: INIT_ZOOM,
  activeLayer: {
    windy: WindyLayers.WIND,
    mapbox2d: MapboxLayers.MAP
  }
}

export default function init (previousState = initialState, action: UpdateMapConfigAction): MapConfig {
  const { type, payload } = action
  if (type === UPDATE_ACTIVE_MAP) {
    return { ...previousState, activeMap: payload.activeMap }
  } else if (type === UPDATE_ACTIVE_LAYER) {
    const activeLayer = {
      ...previousState.activeLayer,
      [payload.map]: payload.layer
    }
    return { ...previousState, activeLayer }
  } else if (type === UPDATE_MAP_ZOOM) {
    return { ...previousState, zoom: payload.zoom }
  } else {
    return previousState
  }
}
